import classnames from 'classnames';
import React from 'react';
import { useDispatch } from 'react-redux';

import { listerClickThrough } from '../../../actions/lister-actions';
import { useIsSmallAndAbove } from '../../../hooks/mediaQueries';
import { isAcceptedRegion } from '../../../utilities/locale-utilities';
import TRANSLATIONS from './translations@default.json';

const isADE = isAcceptedRegion(['ADE']);

export const SmallReviewsLayout = ({
	Rating,
	RatingValue,
	ReviewCount,
	classes,
}) => {
	return (
		<div
			className={classnames('product-card__rating flex text-sm pt-2', classes, {
				'items-center': RatingValue !== '0.0',
				'flex-col': RatingValue === '0.0',
			})}
			itemProp="aggregateRating"
			itemScope
			itemType="http://schema.org/AggregateRating"
			data-testid="small-reviews-layout">
			<meta itemProp="ratingValue" content={RatingValue} />

			<span className={`product-card__rating-stars mr-1 rating-${Rating}`} />

			{RatingValue > 0 && (
				<span className="text-body-xs text-tertiary whitespace-no-wrap">
					<span className="text-caption font-regular">{RatingValue} / 5</span> (
					<span itemProp="ratingCount">
						{ReviewCount} {TRANSLATIONS.reviews.amountOfReviews}
					</span>
					)
				</span>
			)}

			{RatingValue === '0.0' && (
				<div className="text-caption font-regular">
					{TRANSLATIONS.reviews.notYetReviewed}
				</div>
			)}
		</div>
	);
};

const LargeReviewsLayout = ({
	Rating,
	RatingValue,
	ReviewCount,
	FullProductUrl,
	Code,
	classes,
}) => {
	const dispatch = useDispatch();

	return (
		<div
			className={`${classes} product-card__rating text-sm`}
			itemProp="aggregateRating"
			itemScope
			itemType="http://schema.org/AggregateRating"
			data-testid="large-reviews-layout">
			<meta itemProp="ratingValue" content={RatingValue} />

			<a
				href={`${FullProductUrl}#reviewsSection`}
				aria-label={`${RatingValue} out of 5 stars, ${ReviewCount} reviews`}
				onClick={(event) => {
					event.preventDefault();
					window.location.assign(`${FullProductUrl}#reviewsSection`);

					dispatch(listerClickThrough(Code));
				}}
				className="inline-flex flex-wrap items-center text-cta-action font-regular"
				itemProp="url"
				data-testid="product-card-link">
				<span
					className={`rating-${Rating} product-card__rating-stars mt-2 mr-1`}
				/>

				<span className="mt-2 text-link text-body-xs">
					<span className="product-card__rating-value mr-1">
						{isADE
							? `${RatingValue.toString().replace('.', ',')} / 5`
							: `${RatingValue} / 5`}
					</span>

					<span className="product-card__rating-count">
						(
						<span itemProp="ratingCount">
							{ReviewCount} {TRANSLATIONS.reviews.amountOfReviews}
						</span>
						)
					</span>
				</span>
			</a>
		</div>
	);
};

const ReviewRating = (props) => {
	const { Rating, RatingValue, ReviewCount } = props;

	const isSmallAndAbove = useIsSmallAndAbove();

	if (Rating && ReviewCount && RatingValue && RatingValue > 0) {
		if (isSmallAndAbove) {
			return <LargeReviewsLayout {...props} />;
		}

		return <SmallReviewsLayout {...props} />;
	}

	return null;
};

export default ReviewRating;
